import apolloClient from '@/store/apollo';

import TagsGql from '@/store/graphql/queries/Tags.gql';

export default {
    fetchList: variables =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: TagsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_Tags))
                .catch(err => reject(err));
        })
};
